module.exports = __webpack_public_path__ + "img/regulation-1.39a237b2.svg";